export default __webpack_public_path__ + "static/media/aden-te-acompaña-white.59a13214.png";